module.exports = __webpack_public_path__ + "static/media/facilidad.9fd0118b.jpg";